import React from "react";
import { useEffect, useState } from "react";

import { connect } from "react-redux";

import Loader from "../Loader";

import {
  setPromotionPageFeatured,
  setPromotionPageFeaturedFalse,
} from "../../redux/actions/promotions";
import { setAlert } from "../../redux/actions/alerts";

import FeaturedTable from "../Shared/FeaturedTable";
import FeaturedPromotionFormRow from "./Forms/FeaturedPromotionFormRow";
import DeleteForm from "./Forms/DeleteForm";
import Modal from "../Shared/Modal";

import styles from '../../styles/pages/FeaturedContentPages/PromotionPageContent.module.css'


const FeaturedPromotionForm = ({
  setAlert,
  setPromotionPageFeatured,
  setPromotionPageFeaturedFalse,
  promotion: {
    isLoading,
    promotionPageFeatured,
  },
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [missingIndex, setMissingIndex] = useState([])
  const [clear, setClear] = useState(0);
  const [selectedContent, setSelectedContent] = useState(null);
  
  const defaultFeatured = {
    select: null,
    date: null,
    id: null
  }

  const [formValues, setFormValues] = useState([
    defaultFeatured,
    defaultFeatured,
    defaultFeatured,
    defaultFeatured,
    defaultFeatured,
  ])

  useEffect(() => {
      let currentForm = []
    
      if (promotionPageFeatured?.length > 0) {
      
          for (let featured of promotionPageFeatured) {
              
              currentForm = [
                  ...currentForm,
                  {
                      select: featured.promotion_page_item_order,
                      date: featured.promotion_page_expiration_date,
                      id: featured.promotion_id,
                      name: featured.title,
                      featuredId: featured.promotion_id
                  }
              ]
          }
      } else {
        currentForm = [defaultFeatured]
      }
      
      setFormValues([
        ...currentForm
      ])

  }, [promotionPageFeatured]);

  const checkIsEmpty = (i) => {
    const currentForm = formValues[i]

    if (!currentForm || (!currentForm[`select`] && !currentForm[`date`] && !currentForm[`id`] && !currentForm[`name`])) {
        return true
    } else {
        return false
    }
  }
  const validateFields = () => {
    let missing = false
    let missingIndex = []
    for (let i = 0; i < formValues.length; i++) {
        const currentForm = formValues[i]

        if ((!currentForm[`select`] || !currentForm[`date`] || !currentForm[`id`] && !currentForm[`name`]) && !checkIsEmpty(i)) {

            missing = true
            missingIndex.push(i)
        }
    }

    setMissingIndex([...missingIndex])
    return missing

  };

  const processChange = (changingData, i) => {

    let dataToChange = formValues
    dataToChange[i] = {
        ...dataToChange[i],
        ...changingData
    }

    setFormValues([...dataToChange])
  }

  const handleClear = (i) => {
    let dataToChange = formValues

    if (dataToChange[i]?.featuredId) {
        return setSelectedContent(dataToChange[i])
    }

    dataToChange.splice(i, 1)
    
    setFormValues([...dataToChange])
    setMissingIndex([])
  }

  const handleSubmit = async () => {
    if (validateFields()) {
      setAlert("Please fill out all fields below");
    } else {
      setIsDisabled(true);
      setTimeout(() => {
        setIsDisabled(false);
      }, 3000);
      let removedFeatured = await setPromotionPageFeaturedFalse();
      const featuredNewPromotion = {};
      let promotionId = null;

      // Loops through the formValue state and fires off requests for each promotion
      // formValues[promotion][`${promotion}-select`]  will dynamically grab the specific properties on the formValue obj
      for (let i = 0; i < formValues.length; i++) {
        if (checkIsEmpty(i)) {
          continue
        }
                
          featuredNewPromotion.order =
            formValues[i][`select`];
          featuredNewPromotion.expiration_date =
            formValues[i][`date`];
          promotionId = formValues[i].id;
          setPromotionPageFeatured(promotionId, featuredNewPromotion);
        
      }

      setClear(prevClear => prevClear + 1)
    }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <FeaturedTable
          tableName={'Featured Promotions - Featured Promotions Page'}
          subTitle={
              <p className={styles.featured_table_sub_header}>If a promotion is expired, it will fill the remaining slots with "Default Promotions", which are set in the next tab.</p>
          }
          addButtonName={'New Featured'}
          featuredData={formValues}
          FeaturedForm={FeaturedPromotionFormRow}
          handleSubmit={handleSubmit}
          handleChangeData={processChange}
          defaultFeatured={defaultFeatured}
          setFeaturedData={setFormValues}
          missingIndex={missingIndex}
          clearFeaturedRow={handleClear}
          clear={clear}
          addedStyles={{maxWidth: '1920px'}}
          disabled={isDisabled}
          setSelectedContent={setSelectedContent}
      />
      <Modal
          open={selectedContent ? true : false}
          setOpen={() => setSelectedContent(null)}
          component={<DeleteForm
              selectedContent={selectedContent}
              updatedData={{
                  promotion_page_featured: false,
                  promotion_page_expiration_date: null,
                  promotion_page_item_order: null,
              }}
              handleClose={() => setSelectedContent(null)}
          />} 

      />
    </>
   
  );
};

const mapStateToProps = (state) => ({
  promotion: state.promotion,
});

export default connect(mapStateToProps, {
  setAlert,
  setPromotionPageFeatured,
  setPromotionPageFeaturedFalse,
})(FeaturedPromotionForm);
